import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getUserGroup } from "shared-auth";
import {
  BillingUser,
  BillingUserWithoutCommon,
} from "translations/src/models/billing";
import { AccountTypeBillingTypeMap, CheckoutType } from "config/common";

export default function useGetUserType() {
  const memberGroup = getUserGroup();
  const { type } = useParams<{ type: CheckoutType }>();
  const [userType, setUserType] = useState<BillingUserWithoutCommon>();

  useEffect(() => {
    if (type === CheckoutType.Change) {
      return setUserType(BillingUser.PerformerChange);
    }

    if (type === CheckoutType.Graduate) {
      // user will not have graduate member group when entering conversion flow
      return setUserType(BillingUser.GraduateTransfer);
    }

    if (!userType && memberGroup) {
      setUserType(AccountTypeBillingTypeMap[memberGroup]);
    }
  }, [type, userType, memberGroup]);

  return userType;
}
